import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ParseKeyData } from './ParseKeyData';
import { addPartAttribute, delPartAttribute, setPartAttribute, setCacheSearch } from '../../redux/rulesSlice';
import '../../assets/CacheKeyData.css';
import '../../assets/styles.css';


const CacheKeyData = () => {
    const { selectedPart, partAttribute } = useSelector(state => state.rules);
    const createDate = selectedPart.createDate ? new Date(selectedPart.createDate).toISOString().replace("T"," ").substring(0, 19) : '';
    const dispatch = useDispatch();

    let xmlData = [];
    let partType = '';
    if (selectedPart.keyData)
    {
        try {
            xmlData = ParseKeyData(selectedPart.keyData);

            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(selectedPart.keyData, "text/xml");
            
            // Check for XML parsing errors
            const parserError = xmlDoc.querySelector('parsererror');
            if (parserError) {
                console.error('XML parsing error:', parserError.textContent);
            } else {
                const xPath = 'MultipleComponentsMapping Components Component Variables Variable Name';
                const element = xmlDoc.querySelector(xPath);
                partType = element?.textContent || '';
            }
        } catch (error) {
            console.error('Error parsing keyData:', error);
        }
    }

    return (
        <main className="flex flex-col h-screen overflow-hidden bg-white p-2 w-25">
            Serial Number: {selectedPart.serialNumber} <br />
            Create Date: {createDate} <br />
            <br />
            <div>
                <input type='checkbox' checked={selectedPart.sentToAgile ?? false} id="sentToAgile" value="" readOnly={true} /> <label htmlFor="sentToAgile">Sent To Agile</label>
            </div>
            <div>
                <input type='checkbox' checked={selectedPart.cadComplete ?? false} id="cadComplete" value="" readOnly={true} /> <label htmlFor="cadComplete">CAD Complete</label>
            </div>
            <div>
                <input type='checkbox' checked={selectedPart.caDvaulted ?? false} id="caDvaulted" value="" readOnly={true} /> <label htmlFor="caDvaulted">CAD Vaulted</label>
            </div>
            <br />
            <span>Filter(s)
            {partAttribute.length > 1 &&
                <span onClick={()=> dispatch(setPartAttribute([]))} className='headerBlue cursor-pointer'><strong> X</strong></span>
            }
            : 
            {partAttribute.map((attrib, index) => (
                <span key={index} className='inline-block pl-2'>
                    <u>{attrib}
                    <span onClick={()=> dispatch(delPartAttribute(attrib))} className='headerBlue cursor-pointer'><strong> X</strong></span></u>
                </span>
            ))}
            </span>
            <br />
            <div className='h-screen overflow-y-auto'>
            {partType === 'AttributesCollection' &&
                xmlData.map((row, index) => {
                const attrSearch = row['AttrName'] + ':' + row['AttrValue'];
                                return (
                    <div key={index} className='attribCollection'>
                        {Object.keys(row).map((key, rIndex) => {
                            if (rIndex === 0 && !(['BasePart','StartPart_Rev','Raw_Mat_Code','Description']).includes(row[key]))
                                return <span key={rIndex} onClick={() => dispatch(addPartAttribute(row[key]))}  className='headerBlue cursor-pointer span-160'>{row[key]} </span>
                            else if (rIndex === 1 && row['AttrName'] !== 'StartPart_Rev')
                                return <span key={rIndex} onClick={() => dispatch(setCacheSearch(attrSearch))}  className='headerBlue cursor-pointer'><strong>{row[key]}</strong> </span>
                            else
                                return <span key={rIndex} className='span-160'>{row[key]} </span>
                        })}

                    </div>
                )                
            })}
            {partType !== 'AttributesCollection' &&
                xmlData.map((row, index) => {
                return (
                    <div key={index}>
                        {Object.keys(row).map((key, rIndex) => {
                            return <span key={rIndex} className='span-220'>{key}: {row[key]}</span>
                        })}

                    </div>
                )                
            })}
            </div>
        </main>
    )
};

export default CacheKeyData;